// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isCjCredentialsResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      credential_name: string,
      sender_key: string,
      sender_number: string,
      authorization: string,
      channel_name: string,
      channel_uuid: string,
      url: string,
    })
  ),
});
